import React from 'react';

interface KpiTileProps {
  label: string;
  value: string | number;
  /** Small text after the value, e.g. unit or "/last week". */
  suffix?: React.ReactNode;
  icon?: React.ReactNode;
}

/**
 * Compact KPI tile used inside dashboard widgets. Pure presentation —
 * the parent widget owns the data fetch and passes already-formatted values.
 */
const KpiTile: React.FC<KpiTileProps> = ({ label, value, suffix, icon }) => (
  <div className="kpi-tile">
    <div className="kpi-tile-label">
      {icon && <span style={{ marginRight: 4, verticalAlign: 'middle' }}>{icon}</span>}
      {label}
    </div>
    <div className="kpi-tile-value">
      {value}
      {suffix && <span className="kpi-tile-suffix"> {suffix}</span>}
    </div>
  </div>
);

export default KpiTile;
